import './App.css';
import PreLoader from './components/preloader';
import LeftBlock from './components/leftBlock';
import RightBlock from './components/rightBlock';

function App() {
	return (
		<div id="main-wrapper">
			<PreLoader></PreLoader>
			<div class="columns-block container">
				<LeftBlock></LeftBlock>
				<RightBlock></RightBlock>
			</div>
		</div>
	);
}

export default App;
